<!-- eslint-disable no-undef -->
<script>
let LD = window.LD || [];

export default {
  name: 'yext',
  props: {
    mainScript: { type: String, required: true },
    secondaryScript: { type: String, required: true },
    styleSrc: { type: String, required: false },
    apiKey: { type: String, required: true },
    experienceKey: { type: String, required: true },
    experienceVersion: { type: String, required: true },
    locale: { type: String, required: true },
    businessId: { type: String, required: true },
    container: { type: String, required: true },
    name: { type: String, required: true },
    componentName: { type: String, required: true },
    redirectUrl: { type: String, required: true },
    placeholderText: { type: String, required: true },
    submitIcon: { type: String, required: false },
  },
  mounted() {
    this.$nextTick(() => {
      this.createScriptElemnt(this.mainScript, 'yext-main').then(() => {
        this.createScriptElemnt(
          this.secondaryScript,
          'yext-complementary'
        ).then(() => {
          if (this.styleSrc) {
            this.createStyleSrcElement(this.styleSrc);
          }
          const interval = setInterval(() => {
            if (ANSWERS && TemplateBundle) {
              clearInterval(interval);
              this.onFinishLoading();
            }
          }, 300);
        });
      });
    });
  },
  methods: {
    // will check on initial load if url already has query from search
    clearInput() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const container = document.querySelector(this.container);
      const yextInput = container
        ? container.getElementsByClassName('yxt-SearchBar-input')
        : undefined;

      if (urlParams.get('query') && yextInput) {
        this.$nextTick(() => {
          yextInput[0].value = '';
        });
      }
    },
    onFinishLoading() {
      ANSWERS &&
        ANSWERS.init({
          apiKey: this.apiKey,
          experienceKey: this.experienceKey,
          experienceVersion: this.experienceVersion,
          locale: this.locale, // e.g. en
          businessId: this.businessId,
          templateBundle: TemplateBundle ? TemplateBundle.default : '',
          onReady: () => {
            ANSWERS.addComponent(this.componentName, {
              container: this.container,
              name: this.name, //Must be unique for every search bar on the same page
              redirectUrl: this.redirectUrl,
              placeholderText: this.placeholderText,
              submitIcon: this.submitIcon,
            });
          },
        });
      this.clearInput();
    },
    createScriptElemnt(script, scriptName) {
      const normalizedName = scriptName
        .toLowerCase()
        .replaceAll(' ', '_')
        .trim();
      if (LD.includes(normalizedName)) return;
      LD ? LD.push(normalizedName) : (LD = [normalizedName]);

      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.defer = true;

      document.body.appendChild(scriptElement);

      return new Promise((resolve, reject) => {
        scriptElement.onload = () => {
          resolve();
        };

        scriptElement.onerror = () => {
          reject();
        };

        scriptElement.src = script;
      });
    },
    createStyleSrcElement(styleHref) {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';

      document.head.appendChild(link);

      link.href = styleHref;
    },
  },
  render() {},
};
</script>
